import React, { useState } from "react";

import * as S from "./styles";
import { IProps } from "./types";
import { FieldArray, Formik } from "formik";
import { useQuery } from "@apollo/react-hooks";
import { ATTRIBUTES } from "@components/ProductPage/ProductList/queries";
import {
  attributes,
  attributesVariables,
} from "@components/ProductPage/ProductList/__generated__/attributes";
import { Button } from "@atoms";
import { DeviceContext, deviceType } from "@providers";
import { useAlert } from "react-alert";

const SearchFilter: React.FC<IProps> = ({
  initialVariables,
  setVariables,
}: IProps) => {
  const initialVariablesForAttributes: attributesVariables = {
    inCategory:
      "categories" in initialVariables ? initialVariables.categories[0] : null,
    inCollection:
      "collections" in initialVariables
        ? initialVariables.collections[0]
        : null,
  };

  const alert = useAlert();
  const { data, error, loading } = useQuery<attributes>(ATTRIBUTES, {
    variables: initialVariablesForAttributes,
  });

  const isMobile = React.useContext<deviceType>(DeviceContext).isMobile;
  const [isFilterOpen, setIsFilterOpen] = React.useState(!isMobile);

  const handleFilterOpen = () => {
    if (isMobile) {
      setIsFilterOpen(!isFilterOpen);
    }
  };

  const deletePriceIfEmpty = (values) => {
    if (values.priceGte === "") {
      //TODO: Improve it. (cannot convert string to float error when empty)
      delete values["priceGte"];
    }
    if (values.priceLte === "") {
      delete values["priceLte"];
    }
  };

  const handleClick = (values: any) => {
    deletePriceIfEmpty(values);
    setVariables(prev => {
      return { ...prev, ...values };
    });
  };

  return (
    (data && (
      <>
        <S.FilterButton onClick={handleFilterOpen}>FILTER</S.FilterButton>
        {isFilterOpen && (
          <Formik
            initialValues={{
              attributes: [],
              priceLte: "",
              priceGte: "",
            }}
            onSubmit={() => {}}
          >
            {({ values, handleChange }) => {
              return (
                <S.Wrapper>
                  {data &&
                    data.attributes.edges.map((edge, i) => {
                      const attr = edge.node;
                      return (
                        <FieldArray name="attributes" key={i}>
                          {(arrayHelpers) => {
                            return attr.values.map((v, j) => {
                              return (
                                <div key={j}>
                                  <label>
                                    <input
                                      type="checkbox"
                                      name={v.name}
                                      value={v.slug}
                                      onChange={(e) => {
                                        const val = `${attr.slug}:${v.slug}`;
                                        if (e.target.checked) {
                                          arrayHelpers.push(val);
                                        } else {
                                          const idx = values.attributes.indexOf(
                                            val
                                          );
                                          arrayHelpers.remove(idx);
                                        }
                                      }}
                                    />{" "}
                                    {v.name}
                                  </label>
                                </div>
                              );
                            });
                          }}
                        </FieldArray>
                      );
                    })}
                  <S.FilterWrapper>
                    <S.FilterHeader>
                      <S.FilterHeaderTitle>PRICE</S.FilterHeaderTitle>
                    </S.FilterHeader>
                    <S.FilterContent>
                      <S.FilterContentFormWrapper>
                        <input
                          name="priceGte"
                          style={{ width: "40%" }}
                          type="text"
                          placeholder="from"
                          className="form-control d-inline"
                          onChange={handleChange}
                        />
                        <S.FilterRangeSpan> - </S.FilterRangeSpan>
                        <input
                          name="priceLte"
                          style={{ width: "40%" }}
                          type="text"
                          placeholder="to"
                          className="form-control d-inline"
                          onChange={handleChange}
                        />
                      </S.FilterContentFormWrapper>
                    </S.FilterContent>
                    <br />
                  </S.FilterWrapper>
                  <Button
                    onClick={() => {
                      handleClick(values);
                    }}
                  >
                    UPDATE RESULTS
                  </Button>
                </S.Wrapper>
              );
            }}
          </Formik>
        )}
      </>
    )) ||
    null
  );
};

export { SearchFilter };
